import { NgModule } from '@angular/core';
import { AddServicesComponent } from '../non-customer-profile/components/add-services/add-services-component';

@NgModule({
  declarations: [],
  imports: [

  ],
  entryComponents: [

  ],
  providers: []
})
export class CustomerComponentModule { }